<div class="uk-section ">
    <div class="uk-container uk-flex-center">
        <div class="uk-child-width-1-3@s uk-child-width-1-4@m uk-grid-match" uk-grid>
            <div uk-lightbox="animation: fade">
             
                    <a class="uk-inline" href="assets/portfolio/bus1.jpg" data-caption="Offers">
                        <img src="assets/portfolio/bus1.jpg" style="height: 500px; width: 400px;" alt="" uk-img>
                    </a>
                </div>
           
            <div uk-lightbox="animation: fade">
             
                    <a class="uk-inline" href="assets/portfolio/bus2.jpg" data-caption="Bus Ticket">
                        <img src="assets/portfolio/bus2.jpg" style="height: 500px; width: 400px;" alt="" uk-img></a>
                </div>
          
            <div uk-lightbox="animation: fade">
                
                    <a class="uk-inline" href="assets/portfolio/bus3.jpg" data-caption="Mu account">
                        <img src="assets/portfolio/bus3.jpg" style="height: 500px; width: 400px;"  alt="" uk-img></a>
               
            </div>
            <div  uk-lightbox="animation: fade">
                
                    <a class="uk-inline" href="assets/portfolio/bus5.jpg" data-caption="Verification">
                        <img src="assets/portfolio/bus5.jpg" style="height: 500px; width: 400px;" alt="" uk-img></a>
               
            
       
    </div>
</div>